import { render, staticRenderFns } from "./SpreadsheetSettings.vue?vue&type=template&id=3eb7810a"
import script from "./SpreadsheetSettings.vue?vue&type=script&lang=ts"
export * from "./SpreadsheetSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports